import { defineAction } from '~/prix'
import { z } from 'zod'
import { residenceDocumentStatus } from '../residenceDocumentObject'
import residenceDocumentConfirmAction from './residenceDocumentConfirm.action.json' with { type: 'json' }

const residenceDocumentConfirmDefinition = defineAction({
  ...residenceDocumentConfirmAction,

  input: z.object({
    id: z.string().uuid(),
    status: residenceDocumentStatus,
  }),
  output: z.object({}),
})

export default residenceDocumentConfirmDefinition
